import { Route } from 'react-router'
import React from 'react'
import CoreLayout from '../components/CoreLayout'
import Board from './Board'
import Login from './Login'
import NotFound from './NotFound'
import Error from './Error'
import BoardDefsEditor from './BoardDefsEditor'
import { returnPathUpdate, tokenLoad } from '../store/authorization'

const requireAuth = (store) => {
  return (nextState, replace) => {
    store.dispatch(returnPathUpdate(nextState.location.pathname))
    store.dispatch(tokenLoad())
  }
}

const canSeeBoardsEditor = (store) => {
  const allowedEnvs = ['dev', 'blu', 'gra']
  const isAllowedEnv = allowedEnvs.indexOf(store.getState().config.env) >= 0
  return isAllowedEnv
}

export const createRoutes = (store) => (
  <Route>
    <Route path='/login' component={Login} />
    <Route path='/' component={CoreLayout} onEnter={requireAuth(store)}>
      { canSeeBoardsEditor(store) && (
        <Route path='/board/edit' component={BoardDefsEditor} />
      )}
      <Route path='/board/project/:id' component={Board} />
      <Route path='/error(/:errorType)' component={Error} />
      <Route path='/notfound(/:notFoundType)' component={NotFound} />
      <Route path='*' component={NotFound} />
    </Route>
  </Route>
)

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js